<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>Features</p>
                            <img src="../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">

                            <p>Campaigns</p>
                            <img src="../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">
                            <a href="#">{{ $t('Advance.features.Campaigns.onGoingCampaigns.title') }}</a>
                        </div>
                        <div class="according-menu">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <!-- <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true"
                                            aria-controls="collapseOne">
                                            On this page
                                        </button> -->
                                    </h2>
                                    <!-- <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="tableOfContents-list">
                                                <ul id="side_section_info">
                                                    <li id="menu_item_2"
                                                        :class="{ 'active_menu_item': activeMenuItem === 'menu_item_2' }">
                                                        <a href="#features-info">Testing</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>

                            </div>
                        </div>

                        <div class="Introduction-details">

                            <div class="ongoing_wrp">
                                <h1>{{ $t('Advance.features.Campaigns.onGoingCampaigns.title') }}</h1>
                                <p>{{ $t('Advance.features.Campaigns.onGoingCampaigns.ongoingMessage') }}</p>
                                <p><strong>{{ $t('Advance.features.Campaigns.onGoingCampaigns.step1') }}</strong>{{ $t('Advance.features.Campaigns.onGoingCampaigns.clickSidebar') }}</p>

                                <p class="ongoing_img">
                                    <img src="../../../../../assets/images/ongoing-campaigns.webp" class="img-fuild">
                                </p>

                                      
                                <p><strong>{{ $t('Advance.features.Campaigns.onGoingCampaigns.step2') }}</strong>{{ $t('Advance.features.Campaigns.onGoingCampaigns.clickButton') }}</p>

                                <p class="ongoing_img">
                                    <img src="../../../../../assets/images/add-one-off.webp" class="img-fuild">
                                </p>

                                <p>
                                    {{ $t('Advance.features.Campaigns.onGoingCampaigns.inputRequired') }}
                                </p>
                            </div>

                            <div class="table-details" style="padding-left:0;">
                                <table class="table table-bordered description">
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Advance.features.Campaigns.onGoingCampaigns.input') }}</th>
                                            <th>{{ $t('Advance.features.Campaigns.onGoingCampaigns.description') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.titleNew') }}</td>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.campaignName') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.message') }}</td>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.messageCampaign') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.sent') }}</td>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.agent') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.url') }}</td>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.urlCampaigns') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.time') }}</td>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.seconds') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.enable') }}</td>
                                            <td>{{ $t('Advance.features.Campaigns.onGoingCampaigns.whetherCampaign') }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="description_wrp">
                                <p>{{ $t('Advance.features.Campaigns.onGoingCampaigns.campaignSupport') }}<a
                                        href="/docs/product/features/campaigns/wild-card-url-in-campaigns">{{ $t('Advance.features.Campaigns.onGoingCampaigns.guide') }}</a> {{ $t('Advance.features.Campaigns.onGoingCampaigns.wildcard') }}</p>

                                <p><strong>{{ $t('Advance.features.Campaigns.onGoingCampaigns.step3') }}</strong>{{ $t('Advance.features.Campaigns.onGoingCampaigns.visitSpecified') }}</p>

                                    <p class="ongoing_img">
                                    <img src="../../../../../assets/images/campaign-message.webp" class="img-fuild">
                                </p>
                            </div>
                        </div>

                            <div class="edit-update-detail">
                                <!-- <div class="edit-pen">
                                    <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                        aria-hidden="true">
                                        <g>
                                            <path
                                                d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                            </path>
                                        </g>
                                    </svg>
                                    <a href="#">{{ $t('Advance.features.Campaigns.onGoingCampaigns.editPage') }}</a>
                                </div> -->
                                <p>{{ $t('Advance.features.Campaigns.onGoingCampaigns.lastUpdatedOn') }} <span class="dark"> {{ $t('Advance.features.Campaigns.onGoingCampaigns.date') }} </span> {{ $t('Advance.features.Campaigns.onGoingCampaigns.by') }} <span class="dark"> {{ $t('Advance.features.Campaigns.onGoingCampaigns.pranavRaj') }}</span>
                                </p>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="create-chat-woot-account">
                                        <p class="preview">{{ $t('Advance.features.Campaigns.onGoingCampaigns.previous') }}</p>
                                        <router-link to="/docs/user-guide/features/priority" class="introduction-account">
                                            <span>«</span> {{ $t('Advance.features.Campaigns.onGoingCampaigns.preChat') }}
                                        </router-link>

                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="create-chat-woot-account">
                                        <p>{{ $t('Advance.features.Campaigns.onGoingCampaigns.next') }}</p>
                                        <router-link to="/docs/product/features/campaigns/one-off">
                                            {{ $t('Advance.features.Campaigns.onGoingCampaigns.onOff') }}<span>»</span>
                                        </router-link>

                                    </div>
                                </div>
                            </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SideBar from "@/components/SideBar.vue";
// import MainContent from "@/components/MainContent.vue";

export default {
    name: 'ios',
    data() {
        return {
            isToggle: false
        }
    },
    components: {
        Header,
        Footer,
        SideBar,
        // MainContent
    },
    methods: {
        handleToggle() {
            this.isToggle = !this.isToggle
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}
</style>